import { UPDATE_READY_STATE } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function updateCallingReadyState(subject) {
  return callingAPIMethodWithQueue(UPDATE_READY_STATE, subject);
}